<template>
    <div class="all_bills">
        <div class="all_records_top">
            <div>
                <p>账户余额（元）</p>
                <p>¥ {{totalallbalance}}</p>
            </div>
            <div>
                <div>
                    <p>可用余额（元）</p>
                    <p>¥ {{allbalance}}</p>
                </div>
                <el-button type="warning" @click="dialogVisible = true">充值</el-button>
            </div>
        </div>
        <div class="title_box">
            <p class="title_lable">账单明细</p>
        </div>
        <div class="select_box">
            <div class="time_select_box">
                <span>交易时间段</span>
                <el-date-picker v-model="orderData" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions2" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="order_select_box">
                <span>筛选</span>
                <el-select v-model="orderValue" clearable placeholder="全部类型">
                    <el-option
                        v-for="item in orderOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="search_input_box">
                <el-input placeholder="商品名称、订单号" v-model="orderOrGoods" clearable> </el-input>
            </div>
            <div class="search_btn">
                <el-button type="primary" @click="handleQuery()" plain>搜索</el-button>
            </div>
            <div class="export_btn">
                <el-button plain @click="exportClick">导出</el-button>
            </div>
        </div>
        <div class="table_box">
            <el-table :data="allRecordsData" style="width: 100%">
                <el-table-column prop="productname" label="商品名称" align='left'></el-table-column>
                <el-table-column prop="orderno" label="订单号" align='center'></el-table-column>
                <el-table-column prop="datetime" label="时间" align='center'></el-table-column>
                <el-table-column prop="tradetypetext" label="交易类型" align='center'></el-table-column>
                <el-table-column prop="tradesourcetext" label="交易方式" align='center'></el-table-column>
                <el-table-column label="入账/支出（元）" align='center'>
                    <template slot-scope="scope">
                        <span :class="status(scope.row.moneydirect)">{{trademoney(scope.row.moneydirect, scope.row.trademoney)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="备注" align='center'></el-table-column>
            </el-table>
        </div>
        <page :total="total" ref="page" @getList="searchClick"></page>
        <div class="recharge_pop_box">
            <el-dialog title="充值金额" class="recharge" :visible.sync="dialogVisible">
                <div class="top">
                    <p class="title">充值金额</p>
                    <template v-for="item in moneyList" >
                        <input type="radio" name="money" :id="'money_'+item">
                        <label :for="'money_'+item" @click="checkMoney = item; money = ''; topUpMoney = item">
                            <p>{{item}}</p>
                        </label>
                    </template>
                </div>
                <div class="bottom">
                    <p class="title">自定义金额</p>
                    <el-input type="tel" v-model="money" placeholder="输入金额" width="166px" @input="clearRadio"></el-input>
                    <p>输入金额需大于1小于9999的整数</p>
                </div>
                <p class="tips">充值金额不可提现，当前充值金额{{topUpMoney}}元+{{serviceCharge}}（{{topUpMoney}}x1%）服务费={{parseFloat(topUpMoney)+parseFloat(serviceCharge)}}元（含银行交易手续费）</p>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitMoney" :disabled="buttonDisabled">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {hostrecharge} from '@/api/marketingCenterApi' // 引入粉丝管理 api 资源文件
import {findBillToList, findHostMoney, exportOrdersList} from 'api/materialMgtApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import $ from 'jquery'
export default {
    name: 'AllBills',
    props: ['data'],
    data() {
        return {
            money: '',  // 自定义充值金额
            serviceCharge: 0.01, // 手续费
            checkMoney: 0,  // 选中金额
            topUpMoney: 0, // 充值金额
            moneyList: [50,100,500,1000],
            dialogVisible: false, // 充值弹窗
            totalallbalance: null, // 账户余额
            allbalance: null, // 可用余额
            total: 0,
            pickerOptions2: {
                shortcuts: [
                    {
                        text: '今日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            end.setTime(start.getTime() - 3600 * 1000)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            orderData: '',
            orderOrGoods: '',
            orderOptions: [
                {
                    value: '',
                    label: '全部类型'
                },
                {
                    value: 1,
                    label: '充值'
                }, {
                    value: 2,
                    label: '消费'
                }, {
                    value: 3,
                    label: '退款'
                }, {
                    value: 4,
                    label: '收入'
                }, {
                    value: 11,
                    label: '冲正'
                }
            ],

            orderValue: '',
            allRecordsData: [],
            buttonDisabled: true
        }
    },
    mounted() {
        this.getFindHostMoney()
    },
    methods: {
        clearRadio(e) {
            this.checkMoney = 0
            if (Number(e) >= 1 && Number(e) < 9999) {
                if (/^[0-9]*[1-9][0-9]*$/.test(e)) {
                    this.topUpMoney = Number(e)
                    this.buttonDisabled = false
                } else {
                    this.buttonDisabled = true
                    this.$message.error('输入金额需大于1小于9999的整数')
                }
            } else {
                this.buttonDisabled = true
                this.$message.error('输入金额需大于1小于9999的整数')
            }
            $("input[name=money]:checked").prop("checked",false)
            console.log(e)
        },
        // 确认充值
        submitMoney() {

            let money = this.money,
                checkMoney = this.checkMoney,
                m = 0

            // if( money != '') {
            //     // if(/^[0-9]*[1-9][0-9]*$/.test(money)) {
            //     if(true) {
            //         m = money
            //     } else {
            //         this.$message.error('请输入整数')
            //         return
            //     }
            //     m = money
            // }

            // if (checkMoney != 0) {
            //     m = checkMoney
            // }

            // if(m === 0) {
            //     this.$message.error('请选择/输入充值金额')
            //     return
            // }

            if (parseFloat(this.topUpMoney) >= 1 && parseFloat(this.topUpMoney) < 9999) {
                let data = {
                    LoginToken: this.token,
                    ShopID: this.shopID,
                    money: this.topUpMoney,
                    feemoney: this.serviceCharge,
                    hostroletype: this.hostroletype,
                    hostroleinnerid: this.hostroleinnerid
                }
                this.setLoading(true)
                hostrecharge({
                    data: data,
                    success:data => {
                        this.setLoading(false)
                        // 打开充值窗口
                        window.open(data.data.url)

                        console.log(data)

                        this.dialogVisible = false
                        // 打开充值弹窗状态查询窗口
                        this.czialogVisible = true

                        this.czDataApi = {
                            LoginToken: this.token,
                            ShopID: this.shopID,
                            orderno: data.data.orderno,
                            sign: data.data.ordersign
                        }

                        // 遍历充值状态
                        // this.czInterval = setInterval(()=>{
                        //     queryrechargeresult({
                        //         data: this.czDataApi,
                        //         success:data => {
                        //
                        //             if(data.code == '000') {
                        //                 clearInterval(this.czInterval)
                        //                 this.czStatus = 2
                        //                 this.rechargeData = data.data
                        //             }
                        //         },
                        //         error:data => {
                        //             console.log(data)
                        //         }
                        //     })
                        // },30000)


                        // this.$router.push(data.data.url)
                        // location.href = data.data.url
                    },
                    error:data => {
                        this.setLoading(false)
                        console.log(data)
                    }
                })
            } else {
                this.$message.error('输入金额需大于1小于9999的整数')
            }
        },
        // 导出订单
        exportClick() {
            if (this.orderData === null) {
                this.orderData = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderData[0],
                endTime: this.orderData[1],
                orderno: this.orderOrGoods,
                tradetype: this.orderValue
            }
            exportOrdersList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '余额账户' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 分页
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchClick() {
            if (this.orderData === null) {
                this.orderData = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderData[0],
                endTime: this.orderData[1],
                orderno: this.orderOrGoods,
                tradetype: this.orderValue,
                moneydirect: ''
            }
            findBillToList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.allRecordsData = data.data
                    if (data.pageableData !== undefined) {
                        this.total = data.pageableData.rowCount
                    }
                    if (data.data === '') {
                        this.allRecordsData = []
                    }
                    if (data.pageableData === '') {
                        this.total = 0
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取账户余额
        getFindHostMoney() {
            this.setLoading(true)
            findHostMoney({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.totalallbalance = data.data.totalallbalance
                    this.allbalance = data.data.allbalance
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        trademoney(key, value) {
            if (key === 1) {
                return '+' + value
            } else if (key === 2) {
                return '-' + value
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        data(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.allRecordsData = this.data.data
                if (this.data.pageableData !== undefined) {
                    this.total = this.data.pageableData.rowCount
                }
                if (this.data.data === '') {
                    this.allRecordsData = []
                }
                if (this.data.pageableData === '') {
                    this.total = 0
                }
            })
        },
        topUpMoney: {
            handler(newV, oldVal) {
                if (parseFloat(newV) >= 1 && parseFloat(newV) < 9999) {
                    if (/^[0-9]*[1-9][0-9]*$/.test(newV)) {
                        if ((parseFloat(newV) * 0.01).toFixed(2) > 0.01) {
                            this.serviceCharge = (parseFloat(newV) * 0.01).toFixed(2)
                            this.buttonDisabled = false
                        }
                    } else {
                        this.buttonDisabled = true
                        this.$message.error('输入金额需大于1小于9999的整数')
                    }
                } else {
                    this.buttonDisabled = true
                    this.$message.error('输入金额需大于1小于9999的整数')
                }
            }
        }
    },
    computed: {
        status () {
            return function(value) {
                if (value === 1) {
                    return 'green'
                } else if (value === 2) {
                    return 'red'
                }
            }
        },
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .all_bills {
        margin-top: 20px;
        .all_records_top {
            height: 144px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 30px;
            padding-right: 20px;
            background-color: rgba(245, 247, 250, 1);
            font-family: ArialMT;
            &>div{
                width: 50%;
                height: 106px;
            }
            &>div:nth-of-type(1) {
                color: rgba(48, 49, 51, 1);
                p:nth-of-type(1) {
                    font-size: 16px;
                    line-height: 18px;
                    margin-bottom: 30px;
                }
                p:nth-of-type(2) {
                    font-size: 50px;
                    line-height: 58px;
                }
            }
            &>div:nth-of-type(2) {
                padding-right: 36px!important;
                border-left: 1px solid #DCDFE6;
                box-sizing: border-box;
                padding-left: 6%;
                padding-right: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &>div:nth-of-type(1) {
                    p:nth-of-type(1) {
                        font-size: 16px;
                        line-height: 18px;
                        margin-bottom: 30px;
                        white-space: nowrap;
                    }
                    p:nth-of-type(2) {
                        font-size: 30px;
                        line-height: 58px;
                    }
                }
            }
        }
        .title_box{
            margin-top: 30px;
            .title_lable{
                padding-left: 10px;
                border-left: 2px solid #409eff;
                font-size: 16px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: rgba(48, 49, 51, 1);
            }
        }
        .select_box{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-top: 10px;
            &>div{
                margin-top: 20px;
                height: 36px;
                margin-right: 30px;
                display: flex;
                align-items: center;
                &>span{
                    white-space: nowrap;
                    margin-right:10px;
                    color:rgba(48,49,51,1);
                    font-size:14px;
                }
                .el-input__icon {
                    line-height: 0;
                }
                .el-input--suffix .el-input__inner {
                    padding-right: 10px;
                }
                .el-input__inner {
                    height: 36px;
                    line-height: 36px;
                    width: 224px;
                }
            }
            .time_select_box{
                .date_span{
                    color: #303133;
                    font-family:PingFangSC-Regular;
                    cursor: pointer;
                    margin-right:24px;
                }
                .el-input__icon {
                    line-height: 30px;
                }
                .el-input__inner {
                    width: 256px;
                }
                .el-date-editor .el-range-separator {
                    color: #C0C4CC;
                }
                .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
                    height: auto;
                }
            }
            .order_select_box{
                padding-bottom: 5px;
                &>span{
                    margin-top: 5px;
                }
                .el-input__inner {
                    width: 120px;
                }
            }
            .search_input_box{
                padding-bottom: 5px;
                &>span{
                    margin-top: 5px;
                }
                .el-input__inner {
                    width: 256px;
                }
                .el-input__icon {
                    line-height: 36px;
                }
            }
            .search_btn{
                .el-button, .el-button--mini {
                    min-width: 95px;
                }
            }
            .export_btn{
                .el-button, .el-button--mini {
                    min-width: 95px;
                }
            }
        }
        .table_box{
            // min-height: 560px;
            margin-top: 30px;
            .el-table th>.cell {
                color: #303133;
                font-weight: bold;
            }
            .red{
                color: #F56C6C;
            }
            .green{
                color: #67C23A;
            }
        }
        .recharge_pop_box {
            // .el-dialog__wrapper {
            //     display: flex;
            //     justify-content: center;
            //     align-items: center;
            //     text-align: left;
            // }
            .recharge {
                .top {
                    .title {
                        display: inline-block;
                        float: left;
                        color: #303133;
                        line-height: 32px;
                    }
                    input {
                        display: none
                    }
                    input[type=radio]:checked + label {
                        position: relative;
                        border-color: #409EFF;
                    }

                    input[type=radio]:checked + label:after {
                        content: '';
                        position: absolute;
                        top: 0;
                        right: 0;
                        display: block;
                        width: 23px;
                        height: 23px;
                        background: url("../../../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                        background-size: 23px;
                    }

                    label {
                        margin-left: 29px;
                        display: inline-block;
                        width: 95px;
                        height: 32px;
                        text-align: center;
                        cursor: pointer;
                        border: 1px solid rgba(220,223,230,1);
                        border-radius:2px;

                        p {
                            font-size: 14px;
                            color: #606266;
                            line-height: 32px;
                        }
                    }
                }

                .bottom {
                    margin-top: 22px;

                    p {
                        color: #C0C4CC;
                    }
                    p,input {
                        display: inline-block;
                        font-size: 14px;
                        line-height: 32px;
                    }
                    .title {
                        float: left;
                        color: #303133;
                    }

                    .el-input {
                        margin-left: 15px;
                        margin-right: 10px;
                        width: 166px;
                    }


                }
                .tips {
                    margin-top: 10px;
                    color: #C0C4CC;
                    font-size: 14px;
                    line-height: 32px;
                    padding-left: 85px;
                    box-sizing: border-box;
                }
            }
        }
    }
</style>
